import { initializeApp } from 'firebase/app';
import { 
  CACHE_SIZE_UNLIMITED,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  getFirestore,
  Firestore
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCsbBzpbPHTNaO15lKN8toWBPuazln0zfw",
  authDomain: "battlegroundstate-fb1d5.firebaseapp.com",
  projectId: "battlegroundstate-fb1d5",
  storageBucket: "battlegroundstate-fb1d5.firebasestorage.app",
  messagingSenderId: "1003769220553",
  appId: "1:1003769220553:web:c8bca46acf58204e6d2c18",
  measurementId: "G-MS1V27GGDX"
};

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  // If an instance already exists, use that one
  app = initializeApp();
}

// Initialize Firestore with persistence
let db: Firestore;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
      cacheSizeBytes: CACHE_SIZE_UNLIMITED
    })
  });
} catch (error) {
  console.warn('Error initializing Firestore with persistence, falling back to default:', error);
  db = getFirestore(app);
}

// Initialize other Firebase services
const auth = getAuth(app);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export { app, db, auth, analytics, messaging };

// Error handling utilities
export const handleFirebaseError = (error: any) => {
  console.error('Firebase operation failed:', error);
  
  switch (error.code) {
    case 'permission-denied':
      return 'You don\'t have permission to perform this action.';
    case 'unauthenticated':
      return 'Please sign in to continue.';
    case 'unavailable':
      return 'The service is currently unavailable. Please try again later.';
    case 'resource-exhausted':
      return 'You\'ve reached the maximum limit for this operation.';
    default:
      return 'An unexpected error occurred. Please try again.';
  }
}; 